import { render, staticRenderFns } from "./PrbList.vue?vue&type=template&id=45fa9006&scoped=true&"
import script from "./PrbList.vue?vue&type=script&lang=js&"
export * from "./PrbList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fa9006",
  null
  
)

export default component.exports